import { render, staticRenderFns } from "./measurements-modal.vue?vue&type=template&id=9bdc45ae"
import script from "./measurements-modal.vue?vue&type=script&lang=js"
export * from "./measurements-modal.vue?vue&type=script&lang=js"
import style0 from "./measurements-modal.vue?vue&type=style&index=0&id=9bdc45ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports